import React from "react";
import { Grid } from "@material-ui/core";

export const FormRow: React.FC<Omit<React.HTMLProps<HTMLDivElement>, "wrap" | "ref">> = props => (
  <div style={{ margin: 1 }}>
    <Grid container spacing={1} {...props}>
      {props.children}
    </Grid>
  </div>
);
